export const useReviewsStore = defineStore('reviews', () => {
  const params = useParams()
  const confData = useConfdata()
  const webccApi = useWebccApi()

  const rating = ref<ReviewsRating>()
  const reviews = ref<ReviewsSearchResultItem[]>([])
  const reviewCount = ref(0)
  const totalPages = ref(0)
  const loading = ref(false)

  async function translate(
    review: ReviewTranslationParams,
  ): Promise<ReviewTranslation | null> {
    const { data, error } = await webccApi.translate(review)

    if (error.value) return null

    return data.value ?? null
  }

  async function loadReviews(
    page: number,
    geo: { country?: string; region?: string; place?: string },
    language: string = useL10N().language,
    pagesize: number = 20,
    bestReviews: boolean = false,
  ) {
    const { data, error, pending } = await webccApi.reviews(language, {
      ...parseURL(),
      ...removeFalsy(geo),
      ...params.all,
      bestReviews,
      pagesize,
      page,
    })

    loading.value = pending.value

    if (error.value) return

    reviews.value = data.value?.reviews || []
    rating.value = data.value?.rating
    reviewCount.value = data.value?._stats.totalHits || 0
    totalPages.value = Math.ceil(reviewCount.value / pagesize)
  }

  async function fetchBest(searchParams: SearchApiParams, count = 12) {
    return webccApi.reviews(confData.language, {
      ...searchParams,
      bestReviews: true,
      pagesize: count,
    })
  }

  // TODO: add implementation for searchfilterconf in search middleware
  function parseURL() {
    const country = confData.destination?.countryCode as string
    const region = confData.destination?.regionCode as string
    const place = confData.destination?.placeCode as string
    const query = { country, region, place, ...params.persistent }
    const pathelements = useRequestURL()
      .pathname.split('/')
      .filter((p) => !!p)
    const searchfilterconf = (confData.additionalBody as ReviewspageBody)
      .searchfilterconfs
    for (const conf of searchfilterconf || []) {
      if (pathelements.includes(conf.slug.path)) {
        const filtername = conf.filter
        if (['sea', 'lake', 'ski', 'center', 'pax'].includes(filtername)) {
          query[conf.filter] = conf.slug.value
        } else {
          query[conf.filter] = true
        }
      }
    }
    // falsy Werte löschen
    Object.keys(query).forEach((key) => !query[key] && delete query[key])
    return query
  }

  return {
    rating,
    reviews,
    loading,
    reviewCount,
    totalPages,
    loadReviews,
    fetchBest,
    translate,
  }
})
